export default "__VITE_ASSET__D1aDqN1u__"